<template>
  <div>
    <v-card class="ma-3 px-3 py-2">
      <v-layout row class="mb-2">
        <div class="font-weight-medium pt-2 headline mr-3">
          Routes Absence Calendar
        </div>
        <v-spacer></v-spacer>
        <v-btn small color="success" class="mr-2" @click="addAbsentReport()"
          >New Absent Report</v-btn
        >
        <v-btn
          v-if="showUpdateSubDriversButton()"
          small
          color="success"
          class="mr-2"
          @click="openUpdateSubDrivers()"
          >Update Sub Drivers</v-btn
        >
        <v-select
          v-model="kind"
          label="Kind"
          :items="kindOptions"
          item-text="text"
          item-value="value"
          hide-details
          style="max-width: 200px;"
          @change="kindChanged"
        ></v-select>

        <v-select
          style="max-width: 200px;"
          v-model="type"
          :items="types"
          @change="calendarTypeChanged"
          label="Calendar Type"
          hide-details
        ></v-select>
      </v-layout>

      <v-layout row justify-space-between class="mt-0">
        <v-btn
          style="background-color: #fff !important;"
          color="success"
          outline
          @click="goToPerviousMonth()"
        >
          <v-icon left>
            mdi-chevron-left
          </v-icon>
          Prev
        </v-btn>

        <div class="pt-4 headline">
          {{ getHeader() }}
        </div>

        <v-btn
          style="background-color: #fff !important;"
          color="success"
          outline
          @click="goToNextMonth()"
        >
          Next
          <v-icon dark>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </v-layout>

      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
        color="success"
      ></v-progress-linear>

      <v-flex xs12 class="">
        <div v-if="type == 'week'">
          <div style="border: 2px solid rgb(92, 184, 96);">
            <div
              v-for="dates in getDatesOfWeek()"
              class="week-date"
              v-bind:class="{ 'is-today': isToday(dates) }"
            >
              <v-layout row>
                <div
                  class="my-3 width-200"
                  style="border-right: 1px solid #e0e0e0; padding-right: 16px;"
                >
                  <div class="ml-3 mr-2">
                    <div class="display-1 font-weight-regular">
                      {{ dates.weekday }}
                    </div>
                    <div class="title font-weight-light">{{ dates.date }}</div>
                  </div>
                </div>

                <v-layout row class="ml-3 pt-1" style="flex: 1;">
                  <!-- First column: Non-CUSTOM absents -->
                  <v-layout
                    column
                    style="flex: 1; border-right: 1px solid #e0e0e0; padding-right: 8px;"
                  >
                    <div
                      v-for="absent in getAbsentByDate(dates.fulldate).filter(
                        (a) => !a.weekTitle.includes('CUSTOM')
                      )"
                      class="py-1"
                    >
                      <v-layout row>
                        <div
                          style="cursor: pointer;"
                          v-html="absent.weekTitle"
                          :title="absent.groupDetails"
                          @click="onClick(absent)"
                          v-bind:class="{
                            'week-absent-selected': absent.selected,
                          }"
                        ></div>
                        <span
                          class="ml-2 body-2"
                          style="max-height: 24px;"
                          v-bind:class="
                            getGeoUpdatedInfo(absent.absentList).class
                          "
                          >{{ getGeoUpdatedInfo(absent.absentList).text }}</span
                        ><span
                          class="ml-2 body-2"
                          style="max-height: 24px;"
                          v-bind:class="
                            getNotifiedDriverInfo(absent.absentList).class
                          "
                          >{{
                            getNotifiedDriverInfo(absent.absentList).text
                          }}</span
                        >
                        <v-btn
                          class="py-0 my-0"
                          style="max-height: 24px !important;"
                          @click.stop="
                            showDetails(absent.weekTitle, absent.groupDetails)
                          "
                          flat
                          icon
                        >
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </v-layout>
                    </div>
                  </v-layout>

                  <!-- Second column: CUSTOM absents -->
                  <v-layout column style="flex: 1; padding-left: 8px;">
                    <div
                      v-for="absent in getAbsentByDate(dates.fulldate).filter(
                        (a) => a.weekTitle.includes('CUSTOM')
                      )"
                      class="py-1"
                    >
                      <v-layout row>
                        <div
                          style="cursor: pointer;"
                          v-html="absent.weekTitle"
                          :title="absent.groupDetails"
                          @click="onClick(absent)"
                          v-bind:class="{
                            'week-absent-selected': absent.selected,
                          }"
                        ></div>
                        <span
                          class="ml-2 body-2"
                          style="max-height: 24px;"
                          v-bind:class="
                            getGeoUpdatedInfo(absent.absentList).class
                          "
                          >{{ getGeoUpdatedInfo(absent.absentList).text }}</span
                        ><span
                          class="ml-2 body-2"
                          style="max-height: 24px;"
                          v-bind:class="
                            getNotifiedDriverInfo(absent.absentList).class
                          "
                          >{{
                            getNotifiedDriverInfo(absent.absentList).text
                          }}</span
                        >
                        <v-btn
                          class="py-0 my-0"
                          style="max-height: 24px !important;"
                          @click.stop="
                            showDetails(absent.weekTitle, absent.groupDetails)
                          "
                          flat
                          icon
                        >
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </v-layout>
                    </div>
                  </v-layout>
                </v-layout>
              </v-layout>
            </div>
          </div>
        </div>
        <v-sheet v-if="type != 'week'">
          <v-calendar
            style="border: 2px solid #5cb860;"
            v-model="start"
            :end="end"
            color="primary"
            class="routes-calendar"
            ref="calendar"
            :type="type"
            :min-weeks="5"
            interval-height="60"
          >
            <template v-slot:day="{ date }">
              <div
                class="heb-date text--disabled"
                v-bind:class="{
                  'left-68': isFirstOfMonth(date),
                }"
              >
                {{ getDateInfo(date) }}
              </div>

              <v-layout row wrap>
                <template
                  v-if="eventsBusSubMap[date].length"
                  v-for="event in eventsBusSubMap[date]"
                >
                  <v-menu v-model="event.open" full-width offset-x>
                    <template v-slot:activator="{ on }">
                      <div
                        v-ripple
                        class="slot-event slot-event-clickable"
                        v-bind:class="{
                          'slot-assigned-selected':
                            event.selected && event.subDriver,
                          'slot-unassigned-selected':
                            event.selected && !event.subDriver,
                          'slot-event-assigned': event.subDriver,
                          'slot-event-unassigned': !event.subDriver,
                        }"
                        v-html="event.title"
                        @click="onClick(event)"
                        :title="event.groupDetails"
                      ></div>
                    </template>
                    <v-card color="grey lighten-4" min-width="250px">
                      <div
                        style="background-color: #4caf50; color: #fff;"
                        class="pa-2"
                      >
                        {{ "Bus# " + event.busNumber }}
                      </div>
                      <div v-for="absent in event.absentList">
                        <div
                          style="border-radius: 4px; border: 2px solid #4caf50; cursor: pointer;"
                          class="pa-2 ma-2"
                          @click.stop="onEventClicked(absent)"
                        >
                          <div class="pb-1">
                            {{ absent.subDriver }}
                          </div>
                          <div class="">
                            {{ absent.timeStart + " - " + absent.buildings }}
                          </div>
                        </div>
                      </div>
                      <v-card-actions class="ml-2 pt-0 mt-2">
                        <v-btn small dark color="default">
                          Close
                        </v-btn></v-card-actions
                      >
                    </v-card>
                  </v-menu>
                </template>
              </v-layout>
            </template>

            <template v-slot:interval="{ date, hour }">
              <v-layout row wrap>
                <div
                  v-for="event in eventsMap[date]"
                  v-if="event.hour == hour"
                  class="slot-event-daily"
                  v-bind:class="{
                    'slot-assigned-selected': event.selected && event.subDriver,
                    'slot-unassigned-selected':
                      event.selected && !event.subDriver,
                    'slot-event-assigned': event.subDriver,
                    'slot-event-unassigned': !event.subDriver,
                  }"
                  @click="onClick(event)"
                  :title="event.groupDetails"
                  v-html="event.title"
                ></div>
              </v-layout>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-card>

    <v-dialog
      persistent
      scrollable
      v-model="updateAbsentReportDialog"
      :max-width="canEditExistingDeductions ? 1200 : 900"
    >
      <update-absent
        :absent="absentClicked"
        :reload="loadAbsents"
        :closeAbsentReportDialog="closeAbsentReportDialog"
      ></update-absent>
    </v-dialog>

    <v-dialog persistent v-model="updateSubDriversDialog" max-width="1300">
      <update-sub-drivers
        :selected="getSelectedAbsentEvents()"
        :reload="loadAbsents"
        :closeUpdateDialog="closeUpdateSubDriversDialog"
      ></update-sub-drivers>
    </v-dialog>

    <v-dialog v-model="groupDetailsDialog" max-width="600">
      <v-card class="pa-3">
        <div v-html="selectedGroupDetails"></div>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="addAbsentReportDialog"
      max-width="1200"
    >
      <v-card>
        <v-card-title class="success white--text py-2 px-4">
          <span class="title">New Absent Report</span>
          <v-spacer></v-spacer>
          <v-btn icon flat small dark @click="addAbsentReportDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
        <v-layout row wrap>
          <v-flex xs12 sm4 class="pr-3">
            <v-autocomplete
              class="mx-1 mb-0"
              label="Driver / Bus"
              v-model="newAbsentReport.driver_bus"
              :items="newAbsentReport.driver_busList.map((b) => b.displayName)"
              ref="driver_bus"
              clearable
              :rules="[rules.required]"
              @change="driverBusChanged"
            ></v-autocomplete>

            <v-menu
              v-model="newAbsentReport.datePickerMenu"
              :close-on-content-click="false"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newAbsentReport.dates"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newAbsentReport.dates"
                multiple
                @change="datesChanged"
                style="height: 500px;"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  outline
                  small
                  color="success"
                  @click="newAbsentReport.datePickerMenu = false"
                >
                  Ok
                </v-btn>
              </v-date-picker>
            </v-menu>

            <v-autocomplete
              v-model="newAbsentReport.absentReason"
              label="Reason"
              :items="reasons.map((r) => r.reason)"
              ref="absentReason"
              :rules="[rules.required]"
              clearable
            ></v-autocomplete>

            <v-text-field
              v-model="newAbsentReport.note"
              label="Note"
            ></v-text-field>

            <v-text-field
              v-model="newAbsentReport.calendarNote"
              label="Calendar Note"
            ></v-text-field>

            <v-select
              v-model="newAbsentReport.geoUpdated"
              label="GEO Updated"
              :items="['YES', 'NO', 'N/A']"
            ></v-select>

            <v-select
              v-model="newAbsentReport.notifiedDriver"
              label="Notified Driver"
              :items="['YES', 'NO', 'N/A']"
            ></v-select>

            <div class="mt-3 mb-2 font-weight-medium">
              Sub Driver
            </div>
            <v-btn-toggle
              v-model="newAbsentReport.subDriverListFilter"
              @change="newAbsentReportSubDriverListFilterChanged"
            >
              <v-btn flat value="all" class="pa-2">
                <span>All</span>
              </v-btn>
              <v-btn flat value="not_occupied" class="pa-2">
                <span>Not Occupied</span>
              </v-btn>
            </v-btn-toggle>

            <v-autocomplete
              v-model="newAbsentReport.selectedSubDriver"
              :disabled="newAbsentReport.isUpdatingSubDriversList"
              :items="newAbsentReport.subDriversDisplayList"
              hide-details
              box
              chips
              color="success"
              class="mt-3"
              label="Select"
              item-text="displayName"
              item-value="id"
              clearable
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeNewAbsentReportSubDriver(data.item)"
                >
                  {{ data.item.displayName }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="data.item.displayName"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.group"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>

          <v-flex xs12 sm4 class="px-2">
            <v-layout
              class="ml-1 pl-1 mb-2"
              row
              style="max-height: fit-content;"
            >
              <v-select
                class="pt-3"
                v-model="kind"
                label="Kind"
                :items="kindOptions"
                item-text="text"
                item-value="value"
                hide-details
                style="max-width: 200px;"
                @change="driverBusChanged(newAbsentReport.driver_bus)"
              ></v-select>
            </v-layout>

            <v-layout row align-center class="mt-2 mb-2 ml-1 pl-1">
              <v-icon small color="grey darken-1" class="mr-1">mdi-bus</v-icon>
              <span class="font-weight-medium">Routes</span>
            </v-layout>

            <div class="routes-section-card">
              <v-progress-linear
                v-if="newAbsentReport.loadingRoutes"
                :indeterminate="true"
                color="success"
              ></v-progress-linear>
              <div
                v-if="
                  !newAbsentReport.loadingRoutes && !newAbsentReport.routes.length
                "
                class="mt-0 ml-1 pl-1 font-weight-light grey--text"
              >
                {{
                  !newAbsentReport.driver_bus || !newAbsentReport.dates.length
                    ? "Please Select Driver & Dates"
                    : "No Routes"
                }}
              </div>

              <div v-if="newAbsentReport.routes.length" class="route-select-toolbar">
                <v-checkbox
                  class="route-select-all mx-0 my-0 py-0"
                  :input-value="isAllRoutesSelected()"
                  @change="toggleSelectAllRoutes()"
                  label="Select All"
                  color="success"
                  hide-details
                ></v-checkbox>

                <div
                  class="route-group-row"
                  v-if="getRouteGroups().length > 1"
                >
                  <span class="caption grey--text route-group-caption">Select by</span>
                  <label
                    v-for="group in getRouteGroups()"
                    :key="group"
                    class="route-group-chip"
                    :class="{ 'route-group-chip--checked': isGroupFullySelected(group) }"
                    @click.prevent="toggleRouteGroup(group)"
                  >
                    <v-checkbox
                      :input-value="isGroupFullySelected(group)"
                      color="success"
                      hide-details
                      readonly
                      class="route-group-check ma-0 pa-0"
                    ></v-checkbox>
                    <span>{{ group }}</span>
                  </label>
                </div>
              </div>

              <div
                style="overflow-y: auto; max-height: 420px;"
                class="route-list-scroll"
                v-if="newAbsentReport.routes.length"
              >
                <v-checkbox
                  v-for="route in newAbsentReport.routes"
                  :key="routeChoiceKey(route)"
                  class="mx-1 my-0"
                  v-model="newAbsentReport.selectedRoutes"
                  :value="routeChoiceKey(route)"
                  :label="route.displayName"
                  color="success"
                ></v-checkbox>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm4 class="pl-3">
            <absent-deduction-panel
              ref="deductionPanel"
              class="mt-0"
              :driver-bus-id="selectedDriverId"
              :dates="newAbsentReport.dates"
              :kind="kind"
              :route-ids="selectedRouteIds"
              :allow-edit-existing="canEditExistingDeductions"
            ></absent-deduction-panel>
          </v-flex>
        </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="addAbsentReportDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="saveNewAbsentReport()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import crosstab from "vue-crosstab";
import {
  groupBy,
  getDomain,
  onlyUnique,
  toISOLocal,
  getStoredRouteKind,
  setStoredRouteKind,
} from "../../utils/helpers.js";
import DxDateBox from "devextreme-vue/date-box";
import axios from "axios";
import * as Hebcal from "hebcal";
import updateAbsent from "./UpdateAbsent.vue";
import updateSubDrivers from "./UpdateSubDrivers.vue";
import absentDeductionPanel from "./components/AbsentDeductionPanel.vue";
import { canEditExistingDeductions } from "./deductionAccess";

export default {
  components: {
    updateAbsent,
    updateSubDrivers,
    absentDeductionPanel,
  },
  data: () => ({
    downloading: false,
    loading: false,
    processing: false,
    updateSubDriversDialog: false,
    addAbsentReportDialog: false,

    selectedGroupDetails: "",
    groupDetailsDialog: false,

    type: "month",
    types: [
      { text: "Day", value: "day" },
      { text: "Week", value: "week" },
      { text: "Month", value: "month" },
    ],

    absents: [],
    absentsGroup: [],

    hDates: [],
    driver_busList: [],
    eventInfo: "",

    start: moment().format("YYYY-MM-DD"),
    end: moment()
      .add(10, "day")
      .format("YYYY-MM-DD"),

    updateAbsentReportDialog: false,
    absentClicked: {
      driver: "",
      busNumber: "",
      timeStart: "",
      buildings: "",
      grades: "",
      datePickerMenu: false,
      date: "",
    },

    intervalID: "",

    seasons: [],
    season: "",
    kind: "Regular",
    kindOptions: [
      { text: "Regular", value: "Regular" },
      { text: "Day Camp", value: "DayCamp" },
    ],

    newAbsentReport: {
      datePickerMenu: false,
      dates: [],
      driver_bus: "",
      note: "",
      calendarNote: "",
      absentReason: "",
      geoUpdated: "",
      notifiedDriver: "",
      routes: [],
      driver_busList: [],
      selectedRoutes: [],
      loadingRoutes: false,
      selectedSubDriver: "",
      isUpdatingSubDriversList: false,
      subDriversDisplayList: [],
      subDrivers: [],
      subDriverListFilter: "all",
    },

    reasons: [],

    rules: {
      required: (value) => !!value || "Required.",
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
    },
  }),
  watch: {
    "newAbsentReport.dates": {
      handler(newVal) {
        this.datesChanged(newVal);
      },
      deep: true,
    },
  },
  computed: {
    canEditExistingDeductions() {
      return canEditExistingDeductions(this.$store);
    },
    eventsMap() {
      const map = {};
      this.absents.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
    eventsBusSubMap() {
      const map = {};
      this.absentsGroup.forEach((e) =>
        (map[e.date] = map[e.date] || []).push(e)
      );
      return map;
    },
    selectedDriverId() {
      const driver = this.newAbsentReport.driver_busList.find(
        (d) => d.displayName == this.newAbsentReport.driver_bus
      );
      return driver ? driver.id : null;
    },
    selectedRouteIds() {
      return this.distinctRouteIds(this.newAbsentReport.selectedRoutes);
    },
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.intervalID);
  },
  async created() {
    this.loadKind();
    this.loadAbsents();
    this.loadDriverBusList();
    this.loadSeasons();
    this.loadReasons();

    if (this.$route.query.refreshWeek) {
      this.type = "week";
      this.intervalID = setInterval(this.loadAbsents, 300000);
    }
  },
  methods: {
    parseTime(timeStr) {
      if (!timeStr) return Infinity;

      const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (!match) return Infinity; // Invalid format goes to end

      let hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      const period = match[3].toUpperCase();

      // Convert to 24-hour format
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      return hours * 60 + minutes; // Convert to minutes since midnight
    },
    async loadAbsents() {
      try {
        this.loading = true;

        await this.loadHDates();

        let fromDate = moment(this.start)
          .startOf("month")
          .format("YYYY-MM-DD");
        let toDate = moment(this.start)
          .endOf("month")
          .format("YYYY-MM-DD");

        if (this.type == "week") {
          fromDate = moment(this.start)
            .startOf("week")
            .format("YYYY-MM-DD");
          toDate = moment(this.start)
            .endOf("week")
            .format("YYYY-MM-DD");
        }

        const absents = await this.$http.get(
          "api/driverAbsent/getByDateFilter?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&regID=&kind=" +
            this.kind
        );

        this.absents = absents.map((absent) => {
          absent.date = moment(absent.date).format("YYYY-MM-DD");

          let routes = absent.routes;

          routes = (routes || []).filter(
            (r) =>
              !r.weekDays ||
              r.weekDays.includes(this.getDayOfWeek(absent.date))
          );

          absent.title =
            "Bus " +
            (absent.busNumber ? "#" + absent.busNumber : "") +
            (absent.subDriver
              ? " -  #" + this.getBusNumberForDriver(absent.subDriver_Bus_ID)
              : "");

          absent.duration = 60;
          absent.hour = absent.timeStart
            ? this.convertTimeTo24Hour(absent.timeStart)[0] +
              this.convertTimeTo24Hour(absent.timeStart)[1]
            : "";

          absent.open = false;
          absent.busSubGroup =
            absent.date +
            "|" +
            (absent.busNumber ? absent.busNumber : "") +
            "|" +
            (absent.subDriver ? "SubDriver" : "");

          absent.selected = false;
          absent.selectedSubDriver = absent.subDriver_Bus_ID;
          absent.isUpdatingSubDriversList = false;

          const showDetails = true;

          if (showDetails) {
            absent.groupDetails =
              (absent.timeStart ? absent.timeStart : "") +
              " | " +
              (absent.routeIdentifier ? absent.routeIdentifier : "") +
              " | " +
              (absent.groupBy ? absent.groupBy : "") +
              " - " +
              (absent.subDriver
                ? "#" + this.getBusNumberForDriver(absent.subDriver_Bus_ID)
                : "Unassigned") +
              " GEO: " +
              absent.geoUpdated +
              " Notified: " +
              absent.notifiedDriver +
              (absent.calendarNote ? " Note: " + absent.calendarNote : "");
          } else {
            absent.groupDetails = "";
          }

          return absent;
        });

        const group = groupBy(this.absents, "busSubGroup");

        this.absentsGroup = Object.keys(group).map((key) => {
          const absentList = group[key];
          const date = key.split("|")[0];

          let routes = absentList[0].routes;

          const absentDate = absentList[0].date;

          routes = (routes || []).filter(
            (r) =>
              !r.weekDays ||
              r.weekDays.includes(this.getDayOfWeek(absentDate))
          );

          let title =
            "Bus #" +
            key.split("|")[1] +
            " " +
            this.getDriverAbsentGroup(routes, absentList) +
            this.getNotesFromAbsents(absentList);

          let weekTitle =
            "Bus #" +
            key.split("|")[1] +
            " - " +
            this.getDriverAbsentGroup(routes, absentList) +
            this.getNotesFromAbsents(absentList);

          const hasSubDriver = key.split("|")[2] == "SubDriver";

          if (hasSubDriver) {
            title +=
              "<br>" +
              absentList
                .map(
                  (absent) =>
                    "#" + this.getBusNumberForDriver(absent.subDriver_Bus_ID)
                  // +
                  // " " +
                  // this.getDriverAbsentGroup(
                  //   routes,
                  //   absentList,
                  //   absent.subDriver_Bus_ID
                  // )
                )
                .filter(onlyUnique)
                .join("<br>");

            weekTitle +=
              " " +
              absentList
                .map(
                  (absent) =>
                    '<span style="text-decoration: underline; color: #5cb860; cursor: pointer">' +
                    "#" +
                    this.getBusNumberForDriver(absent.subDriver_Bus_ID) +
                    "</span>"
                )
                .filter(onlyUnique);
          } else {
            weekTitle += ` <span style="text-decoration: underline; color: #f44336; cursor: pointer">${
              routes.length ? "Unassigned" : "No Routes"
            }</span>`;
            title += routes.length ? "" : " No Routes";
          }

          let groupDetails = absentList
            .sort((a, b) => {
              const timeA = a.timeStart || "";
              const timeB = b.timeStart || "";

              // If either is empty, put empty ones at the end
              if (!timeA && !timeB) return 0;
              if (!timeA) return 1;
              if (!timeB) return -1;

              return this.parseTime(timeA) - this.parseTime(timeB);
            })
            .map((absent) => {
              return (
                (absent.timeStart ? absent.timeStart : "") +
                " | " +
                (absent.routeIdentifier ? absent.routeIdentifier : "") +
                " | " +
                (absent.groupBy ? absent.groupBy : "") +
                " - " +
                (absent.subDriver
                  ? "#" + this.getBusNumberForDriver(absent.subDriver_Bus_ID)
                  : "Unassigned") +
                " GEO: " +
                absent.geoUpdated +
                " Notified: " +
                absent.notifiedDriver +
                (absent.calendarNote ? " Note: " + absent.calendarNote : "")
              );
            })
            .join("\n");

          return {
            title,
            weekTitle: `<div style="font-weight: bold">` + weekTitle + `</div>`,
            date,
            busNumber: key.split("|")[1],
            subDriver: key.split("|")[2],
            selected: false,
            absentList,
            groupDetails,
          };
        });

        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    getNotesFromAbsents(absentList) {
      if (!absentList) return;

      const notes = absentList
        .filter((a) => a.calendarNote)
        .map((a) => a.calendarNote)
        .filter(onlyUnique)
        .join(", ");

      return notes ? " - " + notes : "";
    },
    async loadSeasons() {
      const seasons = await this.$http.get("api/route/getRouteSeasons");

      this.seasons = seasons.map((s) => s.season);
    },
    loadKind() {
      this.kind = getStoredRouteKind();
    },
    kindChanged(value) {
      this.kind = value;
      setStoredRouteKind(value);
      this.loadAbsents();
    },
    async loadDriverBusList() {
      const response = await this.$http.get("api/route/getDriverBusList");

      this.driver_busList = response
        .map((driverBus) => {
          driverBus.displayName =
            (driverBus.nameH ? driverBus.nameH : driverBus.name) +
            " - " +
            driverBus.busNumber;

          return driverBus;
        })
        .sort((a, b) => {
          const busNumberA = parseInt(a.busNumber) || 0;
          const busNumberB = parseInt(b.busNumber) || 0;
          return busNumberA - busNumberB;
        });

      this.newAbsentReport.driver_busList = this.driver_busList;
    },
    getBusNumberForDriver(driver_Bus_ID) {
      if (driver_Bus_ID == 1) return "No Routes";
      if (!driver_Bus_ID) return "";

      const driver = this.driver_busList.find((d) => d.id == driver_Bus_ID);

      return driver && driver.busNumber ? driver.busNumber : "";
    },
    getDayOfWeek(date) {
      let dayOfWeek = new Date(date).getDay() + 1;

      if (dayOfWeek == 7) {
        dayOfWeek = 0;
      }

      return isNaN(dayOfWeek)
        ? null
        : [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ][dayOfWeek];
    },
    getDriverAbsentGroup(routes, absentList, subDriver_Bus_ID) {
      //const absentDate = absentList[0]?.date;

      if (!routes.length || !absentList.length) return "";

      // Helper to get the day of the week from the date
      const getDayOfWeek = (dateStr) => {
        const date = new Date(dateStr);
        return [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ][date.getDay()];
      };

      // Filter routes to only include those active on the absent date
      //routes = routes.filter((r) => r.weekDays.includes(getDayOfWeek(absentDate)));

      if (!routes.length) return "";

      // Filter absentList by subDriver_Bus_ID if provided
      if (subDriver_Bus_ID) {
        absentList = absentList.filter(
          (a) => a.subDriver_Bus_ID == subDriver_Bus_ID
        );
      }

      // Get the route IDs the driver is absent for
      const absentRouteIds = new Set(absentList.map((a) => a.route_ID));

      // Check which routes the driver is absent for
      const absentRoutes = routes.filter((r) => absentRouteIds.has(r.id));

      // If the driver isn't absent for any assigned routes, return ""
      if (!absentRoutes.length) return "";

      // Get the season from the first absent record (if available)
      const filteredRoutes = routes.filter((r) => {
        if (r.groupBy === "FAM" || r.groupBy === "PPM") return false;
        return true;
      });
      const filteredAbsentRoutes = absentRoutes.filter(
        (r) => r.groupBy !== "FAM" && r.groupBy !== "PPM"
      );

      // If all absent routes are FAM or PPM, return "" (don't categorize)
      if (filteredAbsentRoutes.length === 0) return "";

      // Categorize routes by AM/PM (excluding FAM and PPM)
      const amRoutes = filteredRoutes.filter((r) => r.timeStart.includes("AM"));
      const pmRoutes = filteredRoutes.filter((r) => r.timeStart.includes("PM"));

      // Categorize absent routes by AM/PM (excluding FAM and PPM)
      const absentAMRoutes = filteredAbsentRoutes.filter((r) =>
        r.timeStart.includes("AM")
      );
      const absentPMRoutes = filteredAbsentRoutes.filter((r) =>
        r.timeStart.includes("PM")
      );
      const absentOtherRoutes = filteredAbsentRoutes.filter(
        (r) => !r.timeStart.includes("AM") && !r.timeStart.includes("PM")
      );

      const fullAm =
        amRoutes.length > 0 && absentAMRoutes.length === amRoutes.length;
      const fullPm =
        pmRoutes.length > 0 && absentPMRoutes.length === pmRoutes.length;
      const isALL =
        filteredRoutes.length > 0 &&
        filteredRoutes.every((route) => absentRouteIds.has(route.id));

      if (isALL) return "ALL";
      if (fullAm && absentPMRoutes.length === 0 && absentOtherRoutes.length === 0)
        return "AM";
      if (fullPm && absentAMRoutes.length === 0 && absentOtherRoutes.length === 0)
        return "PM";
      if (
        fullAm &&
        !fullPm &&
        (absentPMRoutes.length > 0 || absentOtherRoutes.length > 0)
      )
        return "AM + CUSTOM";
      if (
        fullPm &&
        !fullAm &&
        (absentAMRoutes.length > 0 || absentOtherRoutes.length > 0)
      )
        return "PM + CUSTOM";

      return "CUSTOM";
    },
    getGeoUpdatedInfo(absentList) {
      const isAllYes = absentList.every((a) => a.geoUpdated == "YES");
      const isAllNo = absentList.every(
        (a) => a.geoUpdated == "NO" || !a.geoUpdated
      );
      const isAllNA = absentList.every((a) => a.geoUpdated == "N/A");
      const isMixed = !(isAllYes || isAllNo || isAllNA);

      let text = "";
      let cssClass = "";

      if (isAllYes) {
        text = "GEO Updated";
      } else if (isAllNo) {
        text = "GEO Not Updated";
      } else if (isAllNA) {
        text = "GEO: N/A";
      } else if (isMixed) {
        text = "GEO: MIXED";
      }

      if (isAllYes) {
        cssClass = "geo-updated";
      } else if (isAllNo) {
        cssClass = "geo-not-updated";
      } else if (isAllNA) {
        cssClass = "geo-na";
      } else if (isMixed) {
        cssClass = "geo-partially-updated";
      }

      // const text = absentList.every((a) => a.geoUpdated == "YES")
      //     ? "GEO Updated"
      //     : absentList.some((a) => a.geoUpdated == "YES")
      //     ? "GEO Partially Updated"
      //     : "GEO Not Updated";

      // const cssClass = absentList.every((a) => a.geoUpdated == "YES")
      //     ? "geo-updated"
      //     : absentList.some((a) => a.geoUpdated == "YES")
      //     ? "geo-partially-updated"
      //     : "geo-not-updated";

      return {
        text: text,
        class: cssClass,
      };
    },
    getNotifiedDriverInfo(absentList) {
      const isAllYes = absentList.every((a) => a.notifiedDriver == "YES");
      const isAllNo = absentList.every(
        (a) => a.notifiedDriver == "NO" || !a.notifiedDriver
      );
      const isAllNA = absentList.every((a) => a.notifiedDriver == "N/A");
      const isMixed = !(isAllYes || isAllNo || isAllNA);

      let text = "";
      let cssClass = "";

      if (isAllYes) {
        text = "Notified Driver";
      } else if (isAllNo) {
        text = "Driver Not Notified";
      } else if (isAllNA) {
        text = "Notified Driver: N/A";
      } else if (isMixed) {
        text = "Notified Driver: MIXED";
      }

      if (isAllYes) {
        cssClass = "geo-updated";
      } else if (isAllNo) {
        cssClass = "geo-not-updated";
      } else if (isAllNA) {
        cssClass = "geo-na";
      } else if (isMixed) {
        cssClass = "geo-partially-updated";
      }

      return {
        text: text,
        class: cssClass,
      };
    },
    convertTimeTo24Hour(timeString) {
      var splitTime = timeString.split(" ");
      var timeHour = splitTime[0].split(":");
      var hours = Number(timeHour[0]);

      if (splitTime[1] === "PM" && hours !== 12) {
        hours += 12;
      }

      hours =
        hours.toString().length === 1
          ? "0" + hours.toString()
          : hours.toString();

      return hours + ":" + timeHour[1];
    },
    async onEventClicked(absent) {
      this.absentClicked = JSON.parse(JSON.stringify(absent));

      this.updateAbsentReportDialog = true;
    },
    onClick(event) {
      event.selected = !event.selected;

      this.$forceUpdate();
    },
    showDetails(weekTitle, groupDetails) {
      this.selectedGroupDetails =
        weekTitle + "<br>" + groupDetails.replaceAll("\n", "<br>");
      this.groupDetailsDialog = true;
    },
    showUpdateSubDriversButton() {
      //if (this.type == "week") return;

      if (this.type == "day") {
        return Object.keys(this.eventsMap)
          .map((key) => {
            return this.eventsMap[key].some((e) => e.selected);
          })
          .some(Boolean);
      }

      return Object.keys(this.eventsBusSubMap)
        .map((key) => {
          return this.eventsBusSubMap[key].some((e) => e.selected);
        })
        .some(Boolean);
    },
    getSelectedAbsentEvents() {
      let selected = [];

      if (this.type == "day") {
        selected = Object.keys(this.eventsMap)
          .map((key) => {
            return this.eventsMap[key];
          })
          .flat()
          .filter((e) => e.selected);
      } else {
        selected = Object.keys(this.eventsBusSubMap)
          .map((key) => {
            return this.eventsBusSubMap[key].filter((e) => e.selected);
          })
          .flat()
          .map((e) => e.absentList)
          .flat();
      }

      return selected;
    },
    calendarTypeChanged(value) {
      this.absents.forEach((a) => (a.selected = false));
      this.absentsGroup.forEach((a) => (a.selected = false));

      this.loadAbsents();

      if (value == "week" && !this.intervalID) {
        this.intervalID = setInterval(this.loadAbsents, 300000);
      }
    },
    openUpdateSubDrivers() {
      this.updateSubDriversDialog = true;
    },
    closeUpdateSubDriversDialog() {
      this.updateSubDriversDialog = false;
    },
    closeAbsentReportDialog() {
      this.updateAbsentReportDialog = false;
    },
    async loadHDates() {
      const fromDate = moment(this.start)
        .startOf("month")
        .format("YYYY-MM-DD");
      const toDate = moment(this.start)
        .endOf("month")
        .format("YYYY-MM-DD");

      const hDates = await this.$http.get(
        "api/driverAbsent/getHDates?startDate=" +
          fromDate +
          "&endDate=" +
          toDate
      );

      this.hDates = hDates;
    },
    getDateInfo(date) {
      const parsedDate = new Date(date + "T00:00:00");

      const hDate = this.hDates.find(
        (d) => moment(d.pardate).format("L") == moment(parsedDate).format("L")
      );

      if (parsedDate.getDay() == 6) return hDate ? hDate.hparsha : "";

      const hebDate = new Hebcal.HDate(parsedDate);

      const month = this.getMonthNumber(hebDate.month, hebDate.year);
      const day = hebDate.day;

      return this.isHoliday(month, day, hebDate.year)
        ? this.getHoliday(month, day, hebDate.year)
        : "";
    },
    isFirstOfMonth(date) {
      const isFirstOfMonth = +date.split("-")[2] == 1;

      return isFirstOfMonth;
    },
    isHoliday(month, dayInMonth, year) {
      switch (`${month}-${dayInMonth}`) {
        case "1-1": //Rosh hashana day 1
        case "1-2": //Rosh hashana day 2
        case "1-9": //Yom kipur
        case "1-10": //Yom kipur
        case "1-14": //Erev Succos
        case "1-15": //Succos day 1
        case "1-16": //succos day 2
        case "1-17": //succos day 3
        case "1-18": //succos day 4
        case "1-19": //succos day 5
        case "1-20": //succos day 6
        case "1-21": //succos day 7
        case "1-22": //shmini atzeres:
        case "1-23": //simchas Torah
        case "7-15": //passover day 1 or shushan purim (leap year)
          return true;

        //non leap year:
        case "6-14": //purim
        case "6-15": //shushan purim
        case "7-16": //passover day 2
        case "7-17": //passover day 3
        case "7-18": //passover day 4
        case "7-19": //passover day 5
        case "7-20": //passover day 6
        case "7-21": //shviei shel pesach
        case "7-22": //achron shel pesach
        case "9-6": //shvous day 1
        case "9-7": //shvuos day 2
        case "11-9": //tishu be-av
          if (!this.isLeapYearHe(year)) return true;
          return false;

        //leap year
        case "7-14": //purim
        case "8-14": //erev passover
        case "8-15": //passover day 1
        case "8-16": //passover day 2
        case "8-17": //passover day 3
        case "8-18": //passover day 4
        case "8-19": //passover day 5
        case "8-20": //passover day 6
        case "8-21": //shviei shel pesach
        case "8-22": //achron shel pesach
        case "10-6": //shvous day 1
        case "10-7": //shvuos day 2
        case "12-9": //tishu be-av
          return true;

        default:
          return false;
      }
    },
    isLeapYearHe(year) {
      const leapYears = [0, 3, 6, 8, 11, 14, 17];
      const yearInCycle = year % 19;
      return leapYears.includes(yearInCycle);
    },
    getMonthNumber(month, year) {
      const isLeapYear = this.isLeapYearHe(year);

      switch (month) {
        case 7:
          return 1;
        case 8:
          return 2;
        case 9:
          return 3;
        case 10:
          return 4;
        case 11:
          return 5;
        case 12:
          return 6;
        case 13:
          return 7;
        case 1:
          return isLeapYear ? 8 : 7;
        case 2:
          return isLeapYear ? 9 : 8;
        case 3:
          return isLeapYear ? 10 : 9;
        case 4:
          return isLeapYear ? 11 : 10;
        case 5:
          return isLeapYear ? 12 : 11;
        case 6:
          return isLeapYear ? 13 : 12;
      }
    },
    getHoliday(month, dayInMonth, year) {
      const isLeapYear = this.isLeapYearHe(year);

      switch (`${month}-${dayInMonth}`) {
        case "1-1":
          return "Rosh Hashana Day 1";
        case "1-2":
          return "Rosh Hashana Day 2";
        case "1-9":
          return "Erev Yom kipur";
        case "1-10":
          return "Yom kipur";
        case "1-14":
          return "Erev Succos";
        case "1-15":
          return "Succos Day 1";
        case "1-16":
          return "Succos Day 2";
        case "1-17":
          return "Succos Day 3";
        case "1-18":
          return "Succos Day 4";
        case "1-19":
          return "Succos Day 5";
        case "1-20":
          return "Succos Day 6";
        case "1-21":
          return "Succos Day 7";
        case "1-22":
          return "Shmini Atzeres:";
        case "1-23":
          return "Simchas Torah";
        case "7-15":
          return !this.isLeapYearHe(year) ? "Passover Day 1" : "Shushan Purim";
          return true;

        //non leap year:
        case "6-14":
          return "Purim";
        case "6-15":
          return "Shushan Purim";
        case "7-16":
          return "Passover day 2";
        case "7-17":
          return "Passover day 3";
        case "7-18":
          return "Passover day 4";
        case "7-19":
          return "Passover day 5";
        case "7-20":
          return "Passover day 6";
        case "7-21":
          return "Shviei shel pesach";
        case "7-22":
          return "Achron shel pesach";
        case "9-6":
          return "Shvous Day 1";
        case "9-7":
          return "Shvuos Day 2";
        case "11-9":
          return "Tishu Be-Av";
          if (!this.isLeapYearHe(year)) return true;
        //return false;

        //leap year
        case "7-14":
          return isLeapYear ? "Purim" : "";
        case "8-14":
          return isLeapYear ? "Erev Passover" : "";
        case "8-15":
          return isLeapYear ? "Passover Day 1" : "";
        case "8-16":
          return isLeapYear ? "Passover Day 2" : "";
        case "8-17":
          return isLeapYear ? "Passover Day 3" : "";
        case "8-18":
          return isLeapYear ? "Passover Day 4" : "";
        case "8-19":
          return isLeapYear ? "Passover Day 5" : "";
        case "8-20":
          return isLeapYear ? "Passover Day 6" : "";
        case "8-21":
          return isLeapYear ? "Shviei Shel Pesach" : "";
        case "8-22":
          return isLeapYear ? "Achron Shel Pesach" : "";
        case "10-6":
          return isLeapYear ? "Shvous Day 1" : "";
        case "10-7":
          return isLeapYear ? "Shvuos Day 2" : "";
        case "12-9":
          return isLeapYear ? "Tishu Be-Av" : "";
          return true;

        default:
          return false;
      }
    },
    getDatesOfWeek() {
      const startOfWeek = moment(this.start).startOf("week");
      const endOfWeek = moment(this.start).endOf("week");

      let currentDate = startOfWeek;
      const weekDates = [];

      while (currentDate <= endOfWeek) {
        weekDates.push({
          weekday: currentDate.format("dddd"),
          date: currentDate.format("DD"),
          fulldate: currentDate.format("L"),
        });
        currentDate = currentDate.add(1, "day");
      }

      return weekDates;
    },
    isToday(date) {
      return moment(date).isSame(new Date(), "day");
    },
    getAbsentByDate(date) {
      const absents = this.absentsGroup
        .filter((a) => moment(a.date).format("L") == date)
        .map((absent) => {
          absent.period = this.periodFromTitle(absent.title);

          return absent;
        })
        .sort((a, b) => {
          // First sort by period (AM, PM, ALL, CUSTOM)
          const periodOrder = { AM: 1, PM: 2, ALL: 3, CUSTOM: 4 };
          const aPeriodOrder = periodOrder[a.period] || 99;
          const bPeriodOrder = periodOrder[b.period] || 99;

          if (aPeriodOrder !== bPeriodOrder) {
            return aPeriodOrder - bPeriodOrder;
          }

          // Then sort by busNumber
          const aBusNumber = parseInt(a.busNumber) || 0;
          const bBusNumber = parseInt(b.busNumber) || 0;
          return aBusNumber - bBusNumber;
        });

      return absents;
    },
    periodFromTitle(title) {
      if (!title) return null;
      if (title.indexOf("CUSTOM") !== -1) return "CUSTOM";
      const match = String(title).match(/\b(AM|PM|ALL)\b/);
      return match ? match[0] : null;
    },
    parseBusString(str) {
      return { period: this.periodFromTitle(str) };
    },
    getHeader() {
      const month = moment(this.start)
        .format("MMMM")
        .toUpperCase();

      let header = month;

      const hDate = this.hDates.find(
        (d) => moment(d.pardate).format("L") == moment(this.start).format("L")
      );

      if (this.type == "week") {
        const startOfWeek = moment(this.start)
          .startOf("week")
          .format("MM/DD");
        const endOfWeek = moment(this.start)
          .endOf("week")
          .format("MM/DD");

        header = "Week Of " + startOfWeek + " - " + endOfWeek;

        if (hDate && hDate.hparsha) {
          header += " (" + hDate.hparsha + ")";
        }
      }

      if (this.type == "day") {
        header = moment(this.start).format("dddd, MMMM D, YYYY");

        if (hDate && hDate.hparsha) {
          header += " (" + hDate.hparsha + ")";
        }
      }

      return header;
    },
    goToNextMonth() {
      if (this.type == "week") {
        const newStartDate = moment(this.start).add(1, "week");

        this.start = newStartDate.format("YYYY-MM-DD");
      } else {
        this.$refs.calendar.next();
      }

      this.loadAbsents();
    },
    goToPerviousMonth() {
      if (this.type == "week") {
        const newStartDate = moment(this.start).subtract(1, "week");

        this.start = newStartDate.format("YYYY-MM-DD");
      } else {
        this.$refs.calendar.prev();
      }

      this.loadAbsents();
    },
    async loadReasons() {
      this.reasons = await this.$http.get(
        "api/driverAbsent/GetDriverAbsentReasons"
      );
    },
    async loadNewAbsentReportSubDriverList() {
      this.newAbsentReport.selectedSubDriver = "";

      const response = await this.$http.post(
        "api/driverAbsent/getSubDrivers",
        []
      );

      this.newAbsentReport.subDrivers = response
        .map((driver) => {
          driver.displayName =
            (driver.nameH ? driver.nameH : driver.name) +
            " (" +
            driver.busNumber +
            ")";

          driver.group = driver.isOccupied ? "Occupied" : "Not Occupied";

          if (driver.position == "Substitute")
            driver.group += ` <span class='substitute-option'>Substitute</span>`;

          return driver;
        })
        .sort((a, b) => {
          if (a.group < b.group) {
            return -1;
          }
          if (a.group > b.group) {
            return 1;
          }
          return 0;
        });

      this.newAbsentReport.subDrivers = this.newAbsentReport.subDrivers.reduce(
        (acc, curr) => {
          const { group } = curr;

          let groupHeader = group;

          groupHeader = groupHeader.replace(
            ` <span class='substitute-option'>Substitute</span>`,
            ``
          );

          const foundIndex = acc.findIndex(
            (item) => item.group === groupHeader
          );
          // if group is not yet added
          if (foundIndex === -1) {
            // add divider after full list of Not Occupied
            if (groupHeader === "Occupied") {
              acc.push({ divider: true });
            }
            acc.push({
              header: groupHeader.toUpperCase(),
            });
          }
          acc.push(curr);
          return acc;
        },
        []
      );

      this.newAbsentReport.subDriversDisplayList = this.newAbsentReport.subDrivers;
    },
    newAbsentReportSubDriverListFilterChanged(value) {
      this.newAbsentReport.subDriversDisplayList =
        value == "all"
          ? this.newAbsentReport.subDrivers
          : this.newAbsentReport.subDrivers.filter(
              (s) => s.group == "Not Occupied"
            );
    },
    removeNewAbsentReportSubDriver(item) {
      this.newAbsentReport.selectedSubDriver = "";
    },
    async datesChanged(value) {
      this.loadRoutesForDriver();
    },
    async driverBusChanged(value) {
      this.loadRoutesForDriver();
    },
    async loadRoutesForDriver() {
      this.newAbsentReport.selectedRoutes = [];

      if (
        !this.newAbsentReport.driver_bus ||
        !this.newAbsentReport.dates.length
      )
        return;

      this.newAbsentReport.loadingRoutes = true;

      try {
        const driver = this.newAbsentReport.driver_busList.find(
          (d) => d.displayName == this.newAbsentReport.driver_bus
        );

        const response = await this.$http.post(
          "api/driverAbsent/getRoutesForDriver?",
          {
            driverID: driver.id,
            regID: "",
            kind: this.kind,
            dates: this.newAbsentReport.dates,
          }
        );

        this.newAbsentReport.routes = response.map((route) => {
          route.displayName =
            route.timeStart +
            " - " +
            route.routeIdentifier +
            " - " +
            route.groupBy;

          return route;
        });

        this.newAbsentReport.loadingRoutes = false;
      } catch (e) {
        this.newAbsentReport.loadingRoutes = false;
      }
    },
    routeChoiceKey(route) {
      return route.id + "|" + (route.routeScheduleID || 0);
    },
    routeByChoice(selected) {
      return this.newAbsentReport.routes.find(
        (route) => this.routeChoiceKey(route) == selected
      );
    },
    distinctRouteIds(selected) {
      const ids = [];
      (selected || []).forEach((choice) => {
        const route = this.routeByChoice(choice);
        if (route && ids.indexOf(route.id) === -1) {
          ids.push(route.id);
        }
      });
      return ids;
    },
    getRouteGroups() {
      if (!this.newAbsentReport.routes.length) return [];

      const group = groupBy(this.newAbsentReport.routes, "groupBy");

      const order = ["AM", "PM", "CUSTOM", "FAM", "PPM"];
      return Object.keys(group).sort(function(a, b) {
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
      });
    },
    // Route keys eligible for "Select All" (FAM/PPM are opt-in only, never bulk-selected).
    selectableRouteKeys() {
      return this.newAbsentReport.routes
        .filter((r) => !["FAM", "PPM"].includes(r.groupBy))
        .map((r) => this.routeChoiceKey(r));
    },
    // Derived straight from selectedRoutes on every render, so it can never drift out of sync
    // with the actual route checkboxes (fixes the checkbox/chip getting "stuck" bug).
    isAllRoutesSelected() {
      const keys = this.selectableRouteKeys();
      if (!keys.length) return false;
      return keys.every((key) =>
        this.newAbsentReport.selectedRoutes.includes(key)
      );
    },
    toggleSelectAllRoutes() {
      const keys = this.selectableRouteKeys();
      if (!keys.length) return;

      if (this.isAllRoutesSelected()) {
        this.newAbsentReport.selectedRoutes = this.newAbsentReport.selectedRoutes.filter(
          (key) => !keys.includes(key)
        );
      } else {
        const merged = this.newAbsentReport.selectedRoutes.slice();
        keys.forEach((key) => {
          if (!merged.includes(key)) merged.push(key);
        });
        this.newAbsentReport.selectedRoutes = merged;
      }
    },
    groupRouteKeys(group) {
      return this.newAbsentReport.routes
        .filter((r) => r.groupBy == group)
        .map((r) => this.routeChoiceKey(r));
    },
    // Derived from selectedRoutes: a group chip is "checked" only when every route in that
    // group is currently selected, whether that happened via the chip or individual checkboxes.
    isGroupFullySelected(group) {
      const keys = this.groupRouteKeys(group);
      if (!keys.length) return false;
      return keys.every((key) =>
        this.newAbsentReport.selectedRoutes.includes(key)
      );
    },
    toggleRouteGroup(group) {
      const keys = this.groupRouteKeys(group);
      if (!keys.length) return;

      if (this.isGroupFullySelected(group)) {
        this.newAbsentReport.selectedRoutes = this.newAbsentReport.selectedRoutes.filter(
          (key) => !keys.includes(key)
        );
      } else {
        const merged = this.newAbsentReport.selectedRoutes.slice();
        keys.forEach((key) => {
          if (!merged.includes(key)) merged.push(key);
        });
        this.newAbsentReport.selectedRoutes = merged;
      }
    },
    validateNewReport() {
      const validations = [
        this.$refs.driver_bus.validate(true),
        this.$refs.absentReason.validate(true),
      ];

      if (
        this.$refs.deductionPanel &&
        !this.$refs.deductionPanel.validate()
      ) {
        return false;
      }

      return validations.every(Boolean);
    },
    getReasonID(reason) {
      const data = this.reasons.find((r) => r.reason == reason);

      return data ? data.id : null;
    },
    async addAbsentReport() {
      this.newAbsentReport.dates = [];
      this.newAbsentReport.driver_bus = "";
      this.newAbsentReport.route = "";
      this.newAbsentReport.routes = [];
      this.newAbsentReport.selectedRoutes = [];
      this.newAbsentReport.selectedSubDriver = "";
      this.newAbsentReport.subDriverListFilter = "all";
      if (this.$refs.deductionPanel) {
        this.$refs.deductionPanel.reset();
      }

      await this.loadNewAbsentReportSubDriverList();
      this.addAbsentReportDialog = true;
    },
    async saveNewAbsentReport() {
      if (!this.validateNewReport()) return;

      if (!this.newAbsentReport.dates.length) {
        return this.$notify({
          text: "Date is required",
          group: "notification",
          type: "error",
        });
      }

      const driver = this.newAbsentReport.driver_busList.find(
        (d) => d.displayName == this.newAbsentReport.driver_bus
      );

      const subDriver = this.newAbsentReport.subDrivers.find(
        (sd) => sd.id == this.newAbsentReport.selectedSubDriver
      );

      const data = this.newAbsentReport.dates
        .map((date) => {
          if (!this.newAbsentReport.selectedRoutes.length) {
            return [
              {
                driver_Bus_ID: driver.id,
                date: date,
                enteredBy: this.$store.state.authentication.user,
                note: this.newAbsentReport.note,
                calendarNote: this.newAbsentReport.calendarNote,
                absentReason: this.newAbsentReport.absentReason,
                geoUpdated: this.newAbsentReport.geoUpdated,
                notifiedDriver: this.newAbsentReport.notifiedDriver,
                absentReasonID: this.getReasonID(
                  this.newAbsentReport.absentReason
                ),
                subDriver_Bus_ID: subDriver ? subDriver.id : null,
              },
            ];
          }

          const chosen = [];
          this.newAbsentReport.selectedRoutes.forEach((selectedRoute) => {
            const route = this.routeByChoice(selectedRoute);
            if (!route) return;
            if (
              route.weekDays &&
              !route.weekDays.includes(this.getDayOfWeek(date))
            ) {
              return;
            }
            if (chosen.some((existing) => existing.id == route.id)) return;
            chosen.push(route);
          });

          return chosen.map((route) => {
              return {
                driver_Bus_ID: driver.id,
                route_ID: route.id,
                date: date,
                enteredBy: this.$store.state.authentication.user,
                note: this.newAbsentReport.note,
                calendarNote: this.newAbsentReport.calendarNote,
                absentReason: this.newAbsentReport.absentReason,
                geoUpdated: this.newAbsentReport.geoUpdated,
                notifiedDriver: this.newAbsentReport.notifiedDriver,

                absentReasonID: this.getReasonID(
                  this.newAbsentReport.absentReason
                ),
                subDriver_Bus_ID: subDriver ? subDriver.id : null,
              };
            });
        })
        .flat();

      if (!data || !data.length) {
        return this.$notify({
          text: "Route selected does not run on selected date/s",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        await this.$http.post("api/driverAbsent/save", data);

        try {
          if (this.$refs.deductionPanel && driver) {
            await this.$refs.deductionPanel.persist(driver.id);
          }
        } catch (payError) {
          this.$notify({
            group: "notification",
            text: payError.body || "Absent saved, but deduction was not saved",
            type: "warning",
          });
        }

        this.processing = false;
        this.addAbsentReportDialog = false;

        this.newAbsentReport.driver_bus = "";
        this.newAbsentReport.absentReason = "";
        this.newAbsentReport.note = "";
        this.newAbsentReport.dates = [];
        this.newAbsentReport.routes = [];
        this.newAbsentReport.selectedRoutes = [];
        this.newAbsentReport.selectedSubDriver = "";
        if (this.$refs.deductionPanel) {
          this.$refs.deductionPanel.reset();
        }

        this.loadAbsents();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
  },
};
</script>
<style>
.route-select-toolbar {
  padding: 4px 4px 10px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.route-select-all {
  margin-bottom: 6px !important;
}
.route-group-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 6px;
}
.route-group-caption {
  margin-right: 10px;
  line-height: 26px;
}
.route-group-chip {
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 16px;
  padding: 2px 10px 2px 4px;
  margin: 0 6px 6px 0;
  cursor: pointer;
  font-size: 13px;
  color: #424242;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.route-group-chip:hover {
  border-color: #66bb6a;
}
.route-group-chip--checked {
  background-color: #e8f5e9;
  border-color: #4caf50;
  color: #2e7d32;
  font-weight: 500;
}
.route-group-check {
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none;
  margin-right: 4px !important;
  pointer-events: none;
}
.route-group-check.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.route-group-check .v-input__control,
.route-group-check .v-input__slot {
  min-height: 0;
}
.route-list-scroll {
  padding-top: 2px;
}
.gray-fg {
  color: #999;
}
.add-slots-button {
  top: 0 !important;
  right: 0px !important;
  position: absolute !important;
  padding-top: 0px !important;
  margin-top: 0px !important;
  padding-bottom: 10px !important;
}
.heb-date {
  top: 0 !important;
  left: 36px !important;
  position: absolute !important;
  padding-top: 4px !important;
  margin-top: 0px !important;
  padding-bottom: 0px !important;
}
.left-68 {
  left: 68px !important;
}
.slot-event {
  /*    white-space: nowrap;*/
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 2px;
  color: #ffffff;
  width: 45%;
  font-size: 12px;
  padding: 3px;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 6px;
  background-color: #30a635;

  &.with-time {
    position: absolute;
    right: 4px;
    height: 24px;
    left: 0px !important;
  }
}

.slot-event-daily {
  overflow: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  color: #ffffff;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
  cursor: pointer;
  min-width: 202px;

  &.with-time {
    position: absolute;
    right: 4px;
    margin-right: 0px;
  }
}
.slot-event-single-date {
  font-size: 15px !important;
  margin-bottom: 3px !important;
}
.slot-event-clickable {
  cursor: pointer;
}
.slot-event-assigned {
  background-color: #5cb860 !important;
}
.slot-event-unassigned {
  background-color: #ff1e1e !important;
}
.slot-assigned-selected {
  background-color: #82e387 !important;
  border: yellow 2px solid !important;
}
.slot-unassigned-selected {
  background-color: #d56969 !important;
  border: yellow 2px solid !important;
}
.routes-calendar .v-calendar-daily__day-interval {
  overflow-y: auto;
  overflow-x: hidden !important;
}
.week-date {
  border-bottom: 1px solid #e0e0e0;
}
.is-today {
  background-color: #eaeaea;
}
.geo-not-updated {
  color: #fff;
  background-color: #f44336;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
}
.geo-updated {
  color: #fff;
  background-color: #5cb860;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
}
.geo-partially-updated {
  color: #fff;
  background-color: orange;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
}
.geo-na {
  background-color: #fff;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
}
.week-absent-selected {
  border: #f44336 2px solid !important;
  background-color: yellow !important;
  color: #f44336 !important;
  padding-right: 4px;
  padding-left: 4px;
}
.substitute-option {
  font-size: 12px;
  background-color: purple;
  color: #fff;
  width: fit-content;
  padding: 3px;
  margin-bottom: 2px;
  border-radius: 5px;
}
.routes-section-card {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
}
</style>
